import { useLayoutEffect } from 'react'
import { isNumber } from 'lodash'

import { SCROLLZONE_ID } from '../components/scroll/ScrollContainer'

export const getScrollbarWidth = (element: HTMLElement | null) => {
  if (!element) return 0
  return element.offsetWidth - element.clientWidth
}

export const getScrollContainerElement = (): HTMLDivElement | null => {
  return document.getElementById(SCROLLZONE_ID) as HTMLDivElement | null
}

export const getAncestorsByCriteria = (
  element: HTMLElement,
  cssSelector: string
): HTMLElement[] => {
  const parent = element?.parentNode as HTMLElement | null
  // parent, because el.closest() can match itself
  const closestAncestor = parent?.closest?.(cssSelector) as HTMLElement | null | undefined

  if (!closestAncestor) {
    return []
  }

  return [closestAncestor, ...getAncestorsByCriteria(closestAncestor, cssSelector)]
}

export const onlyLeafElements = (elementList: HTMLElement[]): HTMLElement[] => {
  return elementList.filter(testedElement =>
    // parentNode, because el.contains() can match itself
    elementList.every(otherElement => !testedElement.contains(otherElement.parentNode))
  )
}

export const moveCursorToEndOfInput = (element: HTMLTextAreaElement | HTMLInputElement) => {
  element.setSelectionRange(element.value.length, element.value.length)
}

export const waitForElementToRender = (
  cssSelector: string,
  pollIntervalMs = 10,
  maxWaitTimeMs = 300
): Promise<Element | null> => {
  const waitExpireTimestamp = Date.now() + maxWaitTimeMs
  return new Promise((resolve, _) => {
    const intervalId = setInterval(() => {
      const element = document.querySelector(cssSelector)

      if (element || Date.now() > waitExpireTimestamp) {
        clearInterval(intervalId)
        resolve(element)
      }
    }, pollIntervalMs)
  })
}

export const useSetElementScrollTop = (elRef: any, scrollTop: number | null | undefined) => {
  useLayoutEffect(() => {
    if (elRef.current && isNumber(scrollTop)) {
      elRef.current.scrollTop = scrollTop
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollTop])
}
